var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.67,
    height: 38.67,
    viewBox: "0 0 38.67 38.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-faq-3615947",
    transform: "translate(-1.998 -2.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3465",
    "data-name": "Path 3465",
    d: "M37.691,31.648a19.334,19.334,0,1,0-7.025,6.625l8.017,2.075a1.289,1.289,0,0,0,1.534-1.682Zm-6.947,5.3a.644.644,0,0,0-.483.064,18.045,18.045,0,1,1,6.181-5.8.644.644,0,0,0-.071.567l2.636,7.321Z",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3466",
    "data-name": "Path 3466",
    d: "M30.466,40.369a1.843,1.843,0,0,0-1.321.49,1.669,1.669,0,0,0-.516,1.25,1.618,1.618,0,0,0,.509,1.244,2.075,2.075,0,0,0,2.662,0,1.637,1.637,0,0,0,.5-1.231,1.669,1.669,0,0,0-.516-1.25A1.83,1.83,0,0,0,30.466,40.369Z",
    transform: "translate(-9.467 -13.638)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3467",
    "data-name": "Path 3467",
    d: "M32.712,20.734a5.485,5.485,0,0,0-3.732-1.16A5.42,5.42,0,0,0,25.223,20.8a4.37,4.37,0,0,0-1.4,3.39H27.1a2.049,2.049,0,0,1,.528-1.424,1.779,1.779,0,0,1,1.341-.522c1.179,0,1.772.644,1.772,1.933a2.365,2.365,0,0,1-.342,1.212,7.186,7.186,0,0,1-1.366,1.482,5.156,5.156,0,0,0-1.411,1.856,6.774,6.774,0,0,0-.387,2.526h2.9l.045-.69a3.126,3.126,0,0,1,.986-1.933l.922-.876A7.379,7.379,0,0,0,33.6,25.838a3.976,3.976,0,0,0,.432-1.824,4.131,4.131,0,0,0-1.321-3.28Z",
    transform: "translate(-7.756 -6.242)",
    fill: "#404040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.7b73ad854046effb7d5696afda993f4f.svg";
export { ForwardRef as ReactComponent };